// extracted by mini-css-extract-plugin
export default {"product-quantity-picker":"product-quantity-picker","btn":"btn"};